module.exports = __webpack_public_path__ + "media/images/qr/extra-rounded-9df4ec9d07c2fd6cf0a9e379e0f0a428.png";